import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  private router = inject(Router);

  /**
   * Determines whether the current route can be activated
   * based on the user's application permissions.
   *
   * @param route Activated route snapshot.
   * @param state Router state snapshot.
   * @returns Returns `true` if the user has permission,
   * otherwise redirects to `/matters` and returns `false`.
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const appPermissions = JSON.parse(localStorage.getItem('app_permissions') || '{}');
    const hasPermission = appPermissions?.[28]?.['System Settings'] == 1;
    if (hasPermission) {
      return true;
    }
    this.router.navigate(['/matters']);
    return false;
  }
}
